import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import CircularProgress from "@material-ui/core/es/CircularProgress/CircularProgress";
import * as moment from "moment";
import React, {Component} from "react";
import {Link} from "react-router-component";
import {SegmentedControl} from "segmented-control";

import ActionBar from "../components/ActionBar";
import Loader from "../components/Loader";
import VLButton from "../components/VLButton";
import * as API from "../util/api";
import * as Render from "../util/Render";
import * as Util from "../util/util";
import PopupStatsGraph from "./PopupStatsGraph";
import VLComponent from "./VLComponent";

export default class CameraCountScreen extends VLComponent {

    constructor() {
        super();
        this.state = {loaded: false, counts: [], open_camera: null, sort: "count"};
    }

    componentDidMount() {
        API.POST("systems/imageCounts", {}, result => {
            if (result.success) {
                this.setState(result.result);
                this.setState({loaded: true});
            }
        });
    }

    render() {
        const currentSort = this.state.sort;
        return (
            <div>
                <ActionBar title="Camera Stats"/>
                <div id="content" style={{
                    display: this.state.loaded ? "flex" : "none",
                    width: "100%",
                    justifyContent: "center",
                    padding: 16,
                    height: "calc(100vh - 85px)", overflowY: "auto"
                }}>
                    <div>
                        <SegmentedControl
                            name="sort"
                            options={[{label: "Count Order", value: "count", default: currentSort === "count"},
                                {label: "Name Order", value: "name", default: currentSort === "name"},
                                {label: "Offline First", value: "offline", default: currentSort === "offline"}
                            ]}
                            setValue={sort => this.setState({sort})}
                            style={{width: "100%", color: window.primary}}/>
                        {this.renderTable()}
                    </div>
                </div>
                <Loader loaded={this.state.loaded}/>

                {this.state.open_camera &&
                <PopupGraph camera_id={this.state.open_camera} navigate={this.props.navigate} close={() => {
                    this.setState({open_camera: null});
                }}/>
                }

                {this.state.open_camera2 &&
                <PopupStatsGraph camera_id={this.state.open_camera2} navigate={this.props.navigate} close={() => {
                    this.setState({open_camera2: null});
                }}/>
                }

            </div>
        );
    }

    renderTable = () => {
        return <table className="w3-table-all" style={{width: "25cm", maxWidth: "90vw"}}>
            <thead>
            <tr className="vl-theme">
                <th>Camera</th>
                <th>Total Images</th>
                <th>Latest Image</th>
                <th/>
                <th/>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td><b>Total</b></td>
                <td><b>{this.state.total}</b></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            {this.renderRows()}
            </tbody>
        </table>;
    };

    renderRows = () => {
        let data = this.state.counts.sort((a, b) => {
            if (this.state.sort == "name") {
                return Util.compare(a.camera_name, b.camera_name);
            } else if (this.state.sort == "offline") {
                return Util.compare(a.online, b.online);
            } else {
                return Util.compare(b.rawCount, a.rawCount);
            }
        });

        return data.map(c => {
            let link = "/camera/" + c.camera_id;
            let bg = c.online == 1 ? "" : "#00A0E4";
            return <tr style={{background: bg}}>
                <td><Link href={link}>{c.camera_name}</Link></td>
                <td>{c.count}</td>
                <td>{c.latest}</td>
                <td><VLButton onClick={() => this.setState({open_camera: c.camera_id})} title="Images Graph"/></td>
                <td><VLButton onClick={() => this.setState({open_camera2: c.camera_id})} title="Apps Graph"/></td>
            </tr>;
        });
    };

}


class PopupGraph extends Component {

    constructor() {
        super();
        this.graphRef = React.createRef();
        this.state = {loaded: false};
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(oldProps, n, p) {
        if (oldProps.camera_id != this.props.camera_id) {

        }
    };

    load = () => {
        API.POST("systems/imageStats", {camera_id: this.props.camera_id}, result => {
            if (result.success) {
                this.setState(result.result, this.loadGraph);
            }
        });
    };

    loadGraph = () => {
        am4core.options.commercialLicense = true;
        let chart = am4core.create(this.graphRef.current, am4charts.XYChart);

        chart.colors.list = [
            am4core.color(window.primary)
        ];

        let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.grid.template.location = 0;

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.tooltip.disabled = true;
        valueAxis.min = 0;

        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.dateX = "date";
        series.dataFields.valueY = "images";
        series.name = "Images";
        series.tooltipText = "{valueY.value} Images\nClick to view";
        series.tooltipHTML = "<span style='color: white'>{dateX.formatDate('dd/MM/yyyy')}: {valueY.value} images<br/><i>Click to view</i></span>";

        chart.cursor = new am4charts.XYCursor();

        let scrollbarX = new am4charts.XYChartScrollbar();
        scrollbarX.series.push(series);
        chart.scrollbarX = scrollbarX;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "Camera Stats";
        chart.legend = new am4charts.Legend();

        let data = this.state.data.map(d => {
            return {
                date: new Date(d.unix * 1000),
                name: "",
                images: d.images
            };
        });
        chart.data = data;

        chart.events.on("hit", this.clickedGraph, this);

        chart.cursor.events.on("cursorpositionchanged", (ev) => {
            let xAxis = ev.target.chart.xAxes.getIndex(0);
            let date = xAxis.positionToDate(xAxis.toAxisPosition(ev.target.xPosition));
            this.hoveredDate = (date);
        });

        /*        chart.events.on("ready", function () {
         dateAxis.zoomToDates(
         new Date(),
         new Date(2019, 3, 26)
         );
         });*/

        this.chart = chart;
        this.setState({loaded: true});
    };

    clickedGraph = () => {
        let time = this.hoveredDate.getTime() / 1000;
        let start = moment.unix(time).startOf("day").unix();
        this.props.navigate("/camera/" + this.props.camera_id + "/images/" + start);
    };

    render() {

        let f = Render.rawOverlay(<div style={{
            height: "calc(100vh - 140px)",
            width: "calc((100vh - 140px) / 9 * 16)",
            background: "white",
            border: "4px solid " + window.primary,
            borderRadius: 16,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            overflow: "hidden"
        }}>

            <div style={{height: "100%", display: "flex", flexDirection: "column"}}>
                <div style={{display: "flex", padding: "0px 16px", alignItems: "center"}} className="vl-theme">
                    <h2 style={{flex: 1}}>{!this.state.loaded ? "Loading..." : this.state.camera}</h2>
                    <i style={{fontSize: 36}} className="material-icons hoverable"
                       onClick={() => this.props.close()}>clear</i>
                </div>
                {!this.state.loaded &&
                <div style={{flex: 1, width: "100%", display: "flex", alignItems: "center", justifyContent: "center"}}>
                    <CircularProgress style={{}} size={100} thickness={2}/>
                </div>
                }

                <div ref={this.graphRef} style={{flex: this.state.loaded ? 1 : 0}}/>
            </div>

        </div>);


        let s = Render.rawOverlay(<div style={{height: "100vh", width: "100vw", background: "rgba(0,0,0,0.7)"}}/>);
        return [s, f];
    };


}
